import * as React from 'react';

import { QuizImportMethods } from '@showbie-socrative/socrative-utils';

import { CreateQuizEventAdapter } from '~analytics/adapters/CreateQuizEventAdapter';
import { PaywallScreens } from '~analytics/types';
import { PaywallDispatch } from '~teacher/components/PaywallDialog';
import {
  QuizToastActions,
  apiToaster,
} from '~teacher/components/quizzes/toastActions';
import {
  handleImportQuizError,
  useImportQuizToPersonalBySocMutation,
} from '~teacher/hook/useImportQuizToPersonalBySocMutation';

interface UseImportQuizBySocToPersonalParams {
  parentId: number;
  onClose: () => void;
  paywallDispatch: PaywallDispatch;
}

export function useImportQuizBySocToPersonal({
  parentId,
  onClose,
  paywallDispatch,
}: UseImportQuizBySocToPersonalParams) {
  const [isImportDisabled, setIsImportDisabled] = React.useState(false);

  const importQuizBySocMutation = useImportQuizToPersonalBySocMutation(
    QuizImportMethods.ByCode
  );

  const importBySocNumber = (socNumber: string) => {
    setIsImportDisabled(true);
    importQuizBySocMutation.mutate(
      { parentId, socNumber },
      {
        onSuccess: (resp) => {
          apiToaster([], QuizToastActions.IMPORT);
          new CreateQuizEventAdapter({
            creation_method: 'code',
            source_soc_number: resp['originalSocNumber'],
          }).sendAnalytics();

          onClose();
        },

        onSettled: () => setIsImportDisabled(false),

        onError: handleImportQuizError(() => {
          //If we are over the quiz limit, we display the paywall.
          onClose();
          paywallDispatch({
            type: 'OPEN',
            touch: [
              PaywallScreens.QuizListLimitReached,
              PaywallScreens.QuizListImportQuiz,
            ],
          });
        }),
      }
    );
  };

  return {
    ...importQuizBySocMutation,
    importBySocNumber,
    isImportDisabled,
  };
}
